import React, {Component} from 'react';
import AppLogo from '../components/AppLogo';
import UserPanel from '../components/UserPanel';
import {Link} from 'react-router-dom';
import {Menu} from 'react-feather';
import DropdownLink from '../components/output/DropdownLink';
import WithRole from '../components/container/WithRole';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import FlagIconFactory from 'react-flag-icon-css';
import './Header.css';
import {
    MACHINERY_CRUD_ENABLED,
    R_PHRASES_AND_SCORE_P_VISIBLE,
    ShowBasedOnConfig,
    VERISK_INTEGRATION_ENABLED
} from "./container/ShowBasedOnConfig";

const FlagIcon = FlagIconFactory(React, {useCssModules: false});

class Header extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {isOpen: false};
    }

    toggleMenu = () => {
        this.setState({isOpen: !this.state.isOpen});
    };

    renderMobileMenu = locale => {
        if (!this.state.isOpen) {
            return;
        }

        return (
            <div className="mobile-menu">
                <WithRole roles={['A', 'B', 'C', 'D']}>
          <span>
            <Link onClick={this.toggleMenu} to="/companies">{getLabel(locale, 'header.registry.companies')}</Link>
            <Link onClick={this.toggleMenu} to="/departments">{getLabel(locale, 'header.registry.departments')}</Link>
            <Link onClick={this.toggleMenu} to="/activities">{getLabel(locale, 'header.registry.activities')}</Link>
            <Link onClick={this.toggleMenu}
                  to="/departments/activities">{getLabel(locale, 'header.departmentActivities')}</Link>
            <Link onClick={this.toggleMenu} to="/h-phrases">{getLabel(locale, 'header.registry.hPhrases')}</Link>
            <ShowBasedOnConfig configKey={R_PHRASES_AND_SCORE_P_VISIBLE}>
              <Link onClick={this.toggleMenu} to="/r-phrases">{getLabel(locale, 'header.registry.rPhrases')}</Link>
            </ShowBasedOnConfig>
            <Link onClick={this.toggleMenu} to="/agents">{getLabel(locale, 'header.registry.agents')}</Link>
              <ShowBasedOnConfig configKey={MACHINERY_CRUD_ENABLED}>
                <Link onClick={this.toggleMenu}
                      to="/machieries">{getLabel(locale, 'header.registry.machineries')}</Link>
              </ShowBasedOnConfig>
          </span>
                </WithRole>
                <WithRole roles={['A', 'B', 'C', 'D']}>
                    <Link onClick={this.toggleMenu} to="/substances">{getLabel(locale, 'header.substances')}</Link>
                </WithRole>
                <WithRole roles={['A', 'B', 'C', 'D']}>
                    <Link onClick={this.toggleMenu}
                          to="/departments/substances">{getLabel(locale, 'header.departmentSubstances')}</Link>
                </WithRole>
                <WithRole roles={['A', 'B', 'C', 'D']}>
                    <Link onClick={this.toggleMenu}
                          to="/substances/management">{getLabel(locale, 'header.substancesManagement')}</Link>
                </WithRole>
                <WithRole roles={['A', 'B']}>
                    <Link onClick={this.toggleMenu}
                          to="/departments/copy">{getLabel(locale, 'header.departmentsCopy')}</Link>
                </WithRole>
                <WithRole roles={['A', 'B', 'E']}>
                    <Link onClick={this.toggleMenu} to="/lots">{getLabel(locale, 'header.lots')}</Link>
                </WithRole>
                <WithRole roles={['A', 'B']}>
                    <Link onClick={this.toggleMenu} to="/users">{getLabel(locale, 'header.users')}</Link>
                </WithRole>
                <WithRole roles={['A', 'B']}>
                    <Link onClick={this.toggleMenu} to="/logs">{getLabel(locale, 'header.logs')}</Link>
                </WithRole>
                <WithRole roles={['A', 'B']}>
                    <Link onClick={this.toggleMenu} to="/import">{getLabel(locale, 'header.import')}</Link>
                </WithRole>
                <WithRole roles={['A']}>
                    <Link onClick={this.toggleMenu} to="/importUsers">{getLabel(locale, 'header.import')}</Link>
                </WithRole>
                <WithRole roles={['A', 'B']}>
        <span>
         <Link onClick={this.toggleMenu} to="/verisksend">{getLabel(locale, 'header.verisk_send')}</Link> 
         <Link onClick={this.toggleMenu} to="/veriskautosend">{getLabel(locale, 'header.verisk_send_startstop')}</Link> 
        </span>
                </WithRole>
                <WithRole roles={['A']}>
          <span>
          <Link to="/veriskbatchsend">{getLabel(locale, 'header.verisk_send_batch')}</Link> 
          </span>
                </WithRole>
                <WithRole roles={['A', 'B', 'C', 'D', 'G']}>
                    <Link onClick={this.toggleMenu}
                          to="/acknowlegmentSDS">{getLabel(locale, 'header.acknowlegmentSDS')}</Link>
                </WithRole>

            </div>
        );
    };

    renderMainMenu = locale => (
        <div style={{padding: '0px 10px'}} className="main-menu">
            <WithRole roles={['A', 'B', 'C', 'D']}>
                <DropdownLink label="header.registry.label">
                    <Link to="/companies">{getLabel(locale, 'header.registry.companies')}</Link>
                    <Link to="/departments">{getLabel(locale, 'header.registry.departments')}</Link>
                    <Link to="/activities">{getLabel(locale, 'header.registry.activities')}</Link>
                    <Link to="/departments/activities">{getLabel(locale, 'header.departmentActivities')}</Link>
                    <Link to="/h-phrases">{getLabel(locale, 'header.registry.hPhrases')}</Link>
                    <ShowBasedOnConfig configKey={R_PHRASES_AND_SCORE_P_VISIBLE}>
                        <Link to="/r-phrases">{getLabel(locale, 'header.registry.rPhrases')}</Link>
                    </ShowBasedOnConfig>
                    <Link to="/agents">{getLabel(locale, 'header.registry.agents')}</Link>
                    <ShowBasedOnConfig configKey={MACHINERY_CRUD_ENABLED}>
                        <Link to="/machineries">{getLabel(locale, 'header.registry.machineries')}</Link>
                    </ShowBasedOnConfig>
                </DropdownLink>
            </WithRole>
            <WithRole roles={['A', 'B', 'C', 'D']}>
                <Link to="/substances">{getLabel(locale, 'header.substances')}</Link>
            </WithRole>
            <WithRole roles={['A', 'B', 'C', 'D']}>
                <Link to="/departments/substances">{getLabel(locale, 'header.departmentSubstances')}</Link>
            </WithRole>
            <WithRole roles={['A', 'B', 'C', 'D']}>
                <Link to="/substances/management">{getLabel(locale, 'header.substancesManagement')}</Link>
            </WithRole>
            <WithRole roles={['A', 'B']}>
                <Link to="/departments/copy">{getLabel(locale, 'header.departmentsCopy')}</Link>
            </WithRole>
            <WithRole roles={['A', 'B', 'E']}>
                <Link to="/lots">{getLabel(locale, 'header.lots')}</Link>
            </WithRole>
            <WithRole roles={['A', 'B']}>
                <Link to="/users">{getLabel(locale, 'header.users')}</Link>
            </WithRole>
            <WithRole roles={['A', 'B']}>
                <Link to="/logs">{getLabel(locale, 'header.logs')}</Link>
            </WithRole>
            <WithRole roles={['A', 'B']}>
                <DropdownLink label="header.import">
                    <Link to="/import">{getLabel(locale, 'header.importSubstances')}</Link>
                    <WithRole roles={['A']}>
                        <Link to="/importusers">{getLabel(locale, 'header.importUsers')}</Link>
                    </WithRole>
                </DropdownLink>
            </WithRole>
            <WithRole roles={['A', 'B']}>
                <ShowBasedOnConfig configKey={VERISK_INTEGRATION_ENABLED}>
                    <DropdownLink label="header.verisk">
                        <Link to="/verisksend">{getLabel(locale, 'header.verisk_send')}</Link>
                        <Link to="/veriskautosend">{getLabel(locale, 'header.verisk_send_startstop')}</Link>
                        <WithRole roles={['A']}>
                            <Link to="/veriskbatchsend">{getLabel(locale, 'header.verisk_send_batch')}</Link>
                        </WithRole>
                    </DropdownLink>
                </ShowBasedOnConfig>
            </WithRole>
            <WithRole roles={['A', 'B', 'C', 'D', 'G']}>
                <DropdownLink label="header.registry.acknowlegment">
                    <Link to="/acknowlegmentSDS">{getLabel(locale, 'header.acknowlegmentSDS')}</Link>
                    <Link to="/acknowlegmentSDS/history">{getLabel(locale, 'header.acknowlegmentSDSHistory')}</Link>
                </DropdownLink>
            </WithRole>
        </div>
    );

    render() {
        const {locale} = this.context;

        return (
            <div className="Header">
                <div className="content">
                    <div className="menu-toggle">
                        <a onClick={this.toggleMenu}><Menu size={18}/></a>
                    </div>
                    <AppLogo/>
                    {this.renderMainMenu(locale)}
                    <div className="lang-toggle">
                        <a onClick={this.props.onLocaleChange}>
                            <span className="tooltip">{getLabel(locale, 'general.toggleLocale')}</span>
                            <FlagIcon code={locale === 'en' ? 'gb' : locale}/>
                        </a>
                    </div>
                    <UserPanel onRequestPasswordChange={this.props.onRequestPasswordChange}/>
                </div>
                {this.renderMobileMenu(locale)}
            </div>
        );
    }
}

Header.contextTypes = {
    locale: PropTypes.string,
};

export default Header;



// WEBPACK FOOTER //
// ./src/main/components/Header.js